<div class="sera-time-progress-bar">
    <div
        *ngIf="isToHaveTitle"
        class="sera-time-progress-bar__top_label">
        <ng-container *ngIf="timeProgressBar.overridenTitle; else defaultTitle">
            <p class="sera-time-progress-bar__top_label__overriden text-label">{{ timeProgressBar.overridenTitle | translate }}</p>
        </ng-container>
        <ng-template #defaultTitle>
            <p class="sera-time-progress-bar__top_label__left">{{ 'PAGE.ANALYSIS.TASK_DURATION.LBL' | translate }}:</p>
            <p class="sera-time-progress-bar__top_label__right">{{ timeOfActivityText }}</p>
        </ng-template>
    </div>
    <div
        class="sera-time-progress-bar__progress_bar"
        [ngClass]="'sera-time-progress-bar__progress_bar__' + progressBarMode">
        <div
            [pTooltip]="(barTooltipText | translate) + ': ' + partialTimeForTooltip + ' ' + (this.timeUnit | translate)"
            tooltipPosition="top"
            [tooltipDisabled]="!shouldShowTooltip"
            [style.width]="timeProgressBar.progressValue + '%'"
            [class]="'sera-time-progress-bar__progress_bar__' + progressBarMode + '__bar'"
            [ngClass]="{
                'sera-time-progress-bar__progress_bar__disabled__hover': timeProgressBar.disableHover || timeProgressBar.progressValue === 100,
                'sera-time-progress-bar__progress_bar__bar': true
            }"></div>
        <p
            [class]="
                timeProgressBar.progressValue && timeProgressBar.progressValue <= 10
                    ? 'sera-time-progress-bar__progress_bar__' + progressBarMode + '__value--relative'
                    : ''
            "
            [ngClass]="{
                'sera-time-progress-bar__progress_bar__value': true,
                'sera-time-progress-bar__progress_bar__value--absolute': timeProgressBar.progressValue && timeProgressBar.progressValue > 10,
                'sera-time-progress-bar__progress_bar__value--relative': timeProgressBar.progressValue && timeProgressBar.progressValue <= 10,
                'sera-time-progress-bar__progress_bar__value--zero': timeProgressBar.progressValue === 0 || timeProgressBar.progressValue === null,
                'sera-time-progress-bar__progress_bar__value--darker': progressBarMode === 'caution'
            }">
            {{ timeProgressBar.progressValue ? (timeProgressBar.progressValue | number : percentageDecimals) : 0 }}%
        </p>
    </div>
    <ds-hint
        *ngIf="timeProgressBar.bottomLabel"
        [tone]="infoTone"
        >{{ timeProgressBar.bottomLabel | translate }}</ds-hint
    >
</div>
